import { BankHoliday } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useFetchBankHolidays() {
  const source = axios.CancelToken.source();
  const [fetching, setFetching] = useState(false);
  const [bankHolidays, setBankHolidays] = useState<BankHoliday[]>([]);

  useEffect(() => {
    return () => source.cancel();
  }, []);

  async function fetchBankHolidays() {
    try {
      setFetching(true);
      const res = await api.fetchBankHolidays(source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setBankHolidays(res.BankHolidays);

      return res;
    } finally {
      setFetching(false);
    }
  }

  return {
    fetching,
    bankHolidays,
    fetchBankHolidays,
  };
}
